/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SourceDoctorSelector.vue?vue&type=template&id=32428800&scoped=true"
import script from "./SourceDoctorSelector.vue?vue&type=script&lang=js"
export * from "./SourceDoctorSelector.vue?vue&type=script&lang=js"
import style0 from "./SourceDoctorSelector.vue?vue&type=style&index=0&id=32428800&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32428800",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32428800')) {
      api.createRecord('32428800', component.options)
    } else {
      api.reload('32428800', component.options)
    }
    module.hot.accept("./SourceDoctorSelector.vue?vue&type=template&id=32428800&scoped=true", function () {
      api.rerender('32428800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patient-reassignment/SourceDoctorSelector.vue"
export default component.exports